export const ACC_OBJ_ID = 2;

export const FRACTION_DIGITS = 4;

export const TypeIds = {
    InventoryTypeId: 1,
    ServiceTypeId: 2,
    NonInventoryTypeId: 3,
    BundleTypeId: 4,
    KitTypeId: 6,
};

export const ObjectNames = {
    CHANNEL_ESTIMATES: "Estimates",
    CHANNEL_SALES_ORDER: "SalesOrders",
    CHANNEL_INVOICING: "Invoicing",
    CHANNEL_CREDIT_MEMO: "Credit Memo",
};

export const CustomAttributeFieldType = {
    FIELD: "FIELD",
    SECTION: "SECTION",
    FOOTER: "FOOTER",
};

export const ContactSelectionType = {
    BILLING: "BILLING",
    SHIPPING: "SHIPPING",
};

export const SoStageId = {
    Entered: 1,
    Pick: 2,
    Pack: 3,
    Shipped: 4,
    Labelling: 5,
    Verification: 6,
    ReadyToShip: 7,
};

export const RmaStages = {
    New: 1,
    Authorized: 2,
    Received: 3,
    Approve_Decline: 4,
    Approved: 5,
    Declined: 6,
};

export const RmaStatus = {
    New: 1,
    Authorized: 2,
    Received: 3,
    Approved: 4,
    Declined: 5,
};

export const PrintType = {
    PRINT: "PRINT",
    PACKSLIPPRINT: "PACKSLIPPRINT",
    PICKSLIPPRINT: "PICKSLIPPRINT",
};

export enum SOChannel {
    PURCHASE_ORDER = "Purchase Order",
    BILL_ORDER = "Bill Order",
    VENDOR_CREDIT = "Vendor Credit",
    ITEM_RECEIPT = "Item Receipt",
    ESTIMATES = "Estimates",
    SALES_ORDER = "Sales Order",
    INVOICING = "Invoicing",
    SALES_RECEIPT = "Sales Receipt",
    CREDIT_MEMO = "Credit Memo",
    CUSTOMER_RETURNS = "Customer Returns",
    OPPORTUNITY = "Opportunity",
}

export enum BackOrderOptions {
    NONE = 0,
    SHIP = 1,
    BACK_ORDER = 2,
    HOLD = 3,
}

export enum ApprovalStatus {
    Default = 0,
    Pending = 1,
    PartiallyApproved = 2,
    Approved = 3,
    Declined = 4
}

export enum ShipmentPackageTYpe {
    SinglePack = "SINGLE_PACKAGE",
    MultiPack = "MULTI_PACKAGE",
}
export enum ShipmentStatus {
    Active = 1,
    InActive = 2,
    Void = 3
}
export enum CreditMemoStatus {
    Open = 1,
    Applied = 2,
    PartiallyApplied = 3,
}

export enum SOEmailAttachmentType {
    EMAILPICKSLIP = "EMAILPICKSLIP",
    EMAILPACKSLIP = "EMAILPACKSLIP",
    EMAILSO = "EMAILSO",
    EMAILINVOICE = "EMAILINVOICE",
}

export enum SOEmailType {
    Estimate = "Estimate",
    Invoice = "Invoice",
    SalesOrder = "SalesOrder",
    SalesReceipt = "SalesReceipt",
    CreditMemo = "CreditMemo",
    CustomerReturn = "CustomerReturn",
    PickSlip = "PickSlip",
    PackSlip = "PackSlip",
}

export enum DialogType {
    CREATE = "CREATE",
    COPY = "COPY",
    EDIT = "EDIT",
    CONVERT = "CONVERT",
    CONVERT_FROM_RMA = "CONVERT_FROM_RMA",
    VIEW = "VIEW",
    STATUS_UPDATE = "STATUS_UPDATE",
}

export const RecentItems = [
    { label: "All Estimates", code: "allestimateorders" },
    { label: "My Estimates", code: "myestimateorders" },
    { label: "New last week", code: "newlastweek" },
    { label: "New this week", code: "newthisweek" },
    { label: "New this month", code: "newthismonth" },
    { label: "Recently Viewed Estimates", code: "recentlyviewedestimates" },
];

export const SalesOrderFilterItems = [
    { label: "All SO", code: "allsalesorders" },
    { label: "Entered SO", code: "entered" },
    { label: "Pick SO", code: "pickorders" },
    { label: "Packed SO", code: "packorders" },
    { label: "Ship SO", code: "shiporders" },
    { label: "Recently Viewed Sales Order", code: "recentlyviewedsalesOrders"},
];

export const InvoicingFilterItems = [
    { label: "All Invoice", code: "allinvoiceorders" },
    { label: "My Invoice", code: "myinvoiceorders" },
    { label: "New last week", code: "newlastweek" },
    { label: "New this week", code: "newthisweek" },
    { label: "New this month", code: "newthismonth" },
    {
        label: "Recently Viewed Invoice",
        code: "recentlyviewedinvoices",
    },
    {
        label: "Open Invoice",
        code: "open",
    },
];

export const CustomerReturnFilterItems = [
    { label: "All Customer RMA", code: "allcustomerrma" },
    { label: "My Customer RMA", code: "mycustomerrma" },
    { label: "New last week", code: "newlastweek" },
    { label: "New this week", code: "newthisweek" },
    { label: "New this month", code: "newthismonth" },
    { label: "Recently Viewed Customer RMA", code: "recentlyviewedrma" },
];

export const CreditMemoFilterItems = [
    { label: "All Credit Memo", code: "allcreditmemos" },
    { label: "My Credit Memo", code: "mycreditmemos" },
    { label: "New last week", code: "newlastweek" },
    { label: "New this week", code: "newthisweek" },
    { label: "New this month", code: "newthismonth" },
    {
        label: "Recently Viewed Credit Memo",
        code: "recentlyviewedcreditmemos",
    },
];

export enum RMA_Stage {
    New = 1,
    Authorized = 2,
    Received = 3,
    Approved = 4,
    Declined = 5,
    Approve_Decline = 6,
}

export enum VRmaStage
{
     Initiation = 1,
     Sent = 2,        
     Approved = 3,
     Declined = 4,
     Approve_Decline = 5,
}

export const CreditByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "number",
        header: "Memo No.",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const ReturnsByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "rmaNumber",
        header: "RMA No.",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const InvoicingTypes = [
    { id: 1, name: "Invoicing" },
    { id: 2, name: "Receive Payments" },
];

export const InvoicingByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "number",
        header: "Invoicing No.",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const OrdersByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "number",
        header: "SO. No.",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const EstimatesByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "number",
        header: "Est. No.",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const AddrTypeDD = [
    {
        id: 1,
        name: "Billing",
        address1: "",
        address2: "",
        countryId: 0,
        country: {
            id: 0,
            name: "",
        },
        stateId: 0,
        state: {
            id: 0,
            name: "",
        },
        cityId: 0,
        city: {
            id: 0,
            name: "",
        },
        zipcode: "",
        attnId: 0,
        attn: {
            id: 0,
            name: "",
        },
        isActive: true,
        isDefault: false,
    },
    {
        id: 2,
        name: "Shipping",
        address1: "",
        address2: "",
        countryId: 0,
        country: {
            id: 0,
            name: "",
        },
        stateId: 0,
        state: {
            id: 0,
            name: "",
        },
        cityId: 0,
        city: {
            id: 0,
            name: "",
        },
        zipcode: "",
        attnId: 0,
        attn: {
            id: 0,
            name: "",
        },
        isActive: true,
        isDefault: false,
    },
];

export const AddressTemp = {
    id: 0,
    name: "",
    address1: "",
    address2: "",
    countryId: 0,
    country: {
        id: 0,
        name: "",
    },
    stateId: 0,
    state: {
        id: 0,
        name: "",
    },
    cityId: 0,
    city: {
        id: 0,
        name: "",
    },
    zipcode: "",
    attnId: 0,
    attn: {
        id: 0,
        name: "",
    },
    isActive: true,
    isDefault: false,
};

export const CustomersByNameCols = [
    {
        field: "id",
        header: "ID",
        show: false,
        value: "",
        checked: false,
        order: false,
    },
    {
        field: "name",
        header: "Customer Name",
        show: true,
        value: "",
        checked: true,
        order: false,
    },
];

export const CustomerTemp = {
    id: 0,
    name: "",
    number: "",
    isActive: "yes",
    description: "",
    address: [],
};

export enum SOObjectNames {
    Estimate = "Estimate",
    SalesOrder = "SalesOrder",
    Invoice = "Invoice",
    CustomerReturns = "Customer RMA",
    CreditMemo = "Credit Memo",
    SalesReceipt = "Sales Receipt",
    RECEIVE_PAYMENT = "Receive Payment",
}

export enum SearchColumns {
    Estimate = "estimateno,accountname,createdate,status,amount,createdby,isactive,refno,estimatedate",
    SalesOrder = "salesorderno,name,createdate,createdby,stage,status,amount,payterms,paymethods,shipterms,shipmethods,location,salesrep,refno,sodate",
    Invoice = "invoiceno,accountname,createdate,createby,amount,dueamount,status,payterms,paymethods,shipterms,shipmethods,salesrep,paymentstatus,refno,invoicedate",
    CustomerReturn = "rmanumber,invoiceno,name,requesttype,location,status,stage",
    CreditMemo = "creditmemono,accountname,createdate,createdby,amount,status,repname,memodate",
    SalesReceipts = "number,accountname,date,refno,amount,status,term,method",
}

export const EstimateFilterColumns = {
    name: "accountname",
};

export const SoFilterColumns = {
    SONo: "salesorderno",
    payterm: "payterms",
    paymethod: "paymethods",
    shipterm: "shipterms",
    shipmethod: "shipmethods",
};

export const InvoiceFilterColumns = {
    number: "invoiceno",
    accountName: "accountname",
    statusName: "status",
    createdDate: "createdate",
    createdBy: "createby",
    totalAmt: "amount",
    dueAmt: "dueamount",
    repname: "repname",
    payterm: "payterms",
    paymethod: "paymethods",
    shipterm: "shipterms",
    shipmethod: "shipmethods",
};

export const CrediMemoFilterColumns = {
    number: "creditmemono",
    accountName: "accountname",
    statusName: "status",
    createdDate: "createdate",
    createdBy: "createdby",
};

export const CustomerReturnFilterColumns = {
    number: "rmano",
    accountName: "accountname",
    statusName: "status",
    rmaValue: "rmavalues",
    createdDate: "createdate",
    createdBy: "createdby",
};

export const accCreditMsg = "You don't have enough credit !!! Please contact administrator";
export const accHoldMsg = "The account credit limit is on hold, Please contact administrator.";

export enum TaxCountry {
    India = 101,
}

export enum TemplateType {
    Estimate = 2,
    SalesOrder = 3,
    Invoice = 4,
    CustomerRMA = 5,
    CreditMemo = 6,
}

export const ImpactsOnGlColumns = [
    { field: 'transactionName', header: 'Transaction Name' },
    { field: 'transactionDate', header: 'Date', dataType: 'date'},
    { field: 'referenceNumber', header: 'Ref. No.' },
    { field: 'financialAccountName', header: 'Account Name' },
    { field: 'classification', header: 'Finance Account Type' },
    { field: 'financialAccountGroup', header: 'Finance Account Group' },
    { field: 'debit', header: 'Debit' , dataType: 'number'},
    { field: 'credit', header: 'Credit', dataType: 'number' }
]

export const TabHeaderConst = {
    Overview: "Overview",
    Transactions: "Transactions",
    Invoices: "Invoices",
    ImpactsOnGL: "Impacts on G/L"
}
